import { useState } from 'react'
import { Modal } from 'almanac-ui/Modal'
import { ContentCategory, ContentTypeCounts, DEFAULT_CONTENT_TYPE_COUNTS } from 'utils/brandPlans/contentCategories'
import { ContentTypeGrid } from './ContentTypeGrid'

interface ContentTypeDefaultsProps {
  initialCounts?: Partial<ContentTypeCounts>
  onConfirm: (counts: ContentTypeCounts) => void
  onBack: () => void
}

export const ContentTypeDefaults = ({ initialCounts, onConfirm, onBack }: ContentTypeDefaultsProps) => {
  const [counts, setCounts] = useState<ContentTypeCounts>(() => ({
    ...DEFAULT_CONTENT_TYPE_COUNTS,
    ...initialCounts,
  }))

  const handleCountChange = (category: ContentCategory, delta: number) => {
    setCounts((prev) => ({
      ...prev,
      [category]: Math.max(0, prev[category] + delta),
    }))
  }

  return (
    <>
      <Modal.Header title="Set the default content types for your campaigns" />
      <Modal.Content fillAvailableSpace>
        <ContentTypeGrid counts={counts} onCountChange={handleCountChange} />
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton size="lg" variant="tertiary" onPress={onBack}>
            Back
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton size="lg" onPress={() => onConfirm(counts)}>
            Review Campaign Themes
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
